import { render, staticRenderFns } from "./FormProcedure.vue?vue&type=template&id=53b2fbee&scoped=true"
import script from "./FormProcedure.vue?vue&type=script&lang=js"
export * from "./FormProcedure.vue?vue&type=script&lang=js"
import style0 from "./FormProcedure.vue?vue&type=style&index=0&id=53b2fbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2fbee",
  null
  
)

export default component.exports